import { message } from "antd";
import { BaseMicroservicesResponse } from "../@types/api/base";
import { MediaType } from "../@types/api/media";

const baseUrl = process.env.NEXT_PUBLIC_LANGUAGE_LIST_URL;
// const baseUrl = "http://43.132.233.53:28000";

// 获取电子书列表
export const getEbookList = async (data: {
	lang_code: {
		lang_code: string;
	};
	page: number;
	limit: number;
	category_id_list?: number[];
}): Promise<BaseMicroservicesResponse<MediaType.EbookListResponse> | null> => {
	try {
		const res = await fetch(`${baseUrl}/medias/get_ebook_list`, {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"Content-Type": "application/json",
			},
		});

		if (res.status === 200) {
			const result = await res.json();
			return result as BaseMicroservicesResponse<MediaType.EbookListResponse>;
		}
		return null;
	} catch (error) {
		console.error("Failed to fetch ebook list:", error);
		message.error("获取电子书列表失败");
		return null;
	}
};

// 获取电子书详情
export const getEbookDetail = async (data: any) => {
	return new Promise((resolve, reject) => {
		fetch(`${baseUrl}/medias/ebook_detail`, {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then(async (r: any) => {
				const res = await r.json();
				if (res.code === 200) {
					resolve(res);
				} else {
					reject(res);
				}
			})
			.catch((err) => {
				reject(null);
			});
	});
};

// 下载电子书
export const downloadEbook = async (data: any, name: string) => {
	return new Promise((resolve, reject) => {
		fetch(`${baseUrl}/medias/get_ebook`, {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"Content-Type": "application/json",
			},
		})
			.then(async (r: any) => {
				if (r.ok) {
					r.headers.forEach((element) => {
						console.log(element);
					});
					const blob = await r.blob();
					// 创建一个指向Blob对象的URL
					const urlObject = URL.createObjectURL(blob);
					// 创建一个<a>元素并模拟点击以下载文件
					const a = document.createElement("a");
					a.href = urlObject;
					a.download = name;
					document.body.appendChild(a);
					a.click();
					resolve(r);
				} else {
					reject(r?.msg);
				}
			})
			.catch((err) => {
				debugger;
				reject(err);
			});
	});
};

// 图片url批量查询
export const getBulkImage = async (data: any) => {
	try {
		const res: any = await fetch(`${baseUrl}/medias/get_bulk_image`, {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				lang: "en",
				"Content-Type": "application/json",
			},
		});

		return res.status === 200 ? res.json() : [];
	} catch (error) {
		message.error("Fail to fetch data");
		return [];
	}
};

// 电子书分类查询
// POST /medias/ebook_category_filter
// level参数，int类型。用以进行分层筛选。传入参数1-5，1为一级分类以此类推。分类最多支持5级所以参数最多为5。若查全部分类则不传入该字段即可。
// keyword字段与level字段均单独生效，不作联合搜索
export const getEbookCategory = async (data: {
	lang_code: {
		lang_code: string;
	};
	keyword?: string;
	level?: number;
}): Promise<BaseMicroservicesResponse<MediaType.EbookCategoryResponse> | null> => {
	try {
		const res = await fetch(`${baseUrl}/medias/ebook_category_filter`, {
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"Content-Type": "application/json",
			},
		});

		if (res.status === 200) {
			const result = await res.json();
			return result as BaseMicroservicesResponse<MediaType.EbookCategoryResponse>;
		}
		return null;
	} catch (error) {
		console.error("Failed to fetch ebook categories:", error);
		message.error("获取电子书分类失败");
		return null;
	}
};

//电子书分类详情查询
// get /medias/ebook_category_detail
// cls_id 分类id
// lang_code: LangCode
export const getEbookCategoryDetail = async (
	cls_id: number,
	lang_code: string,
): Promise<BaseMicroservicesResponse<MediaType.EbookListResponse> | null> => {
	try {
		const params = new URLSearchParams({
			cls_id: cls_id.toString(),
			lang_code: lang_code,
		});
		const res = await fetch(`${baseUrl}/medias/ebook_category_detail?${params.toString()}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
			},
		});

		if (res.status === 200) {
			const result = await res.json();
			return result as BaseMicroservicesResponse<MediaType.EbookListResponse>;
		}
		return null;
	} catch (error) {
		console.error("Failed to fetch ebook category detail:", error);
		message.error("获取电子书分类详情失败");
		return null;
	}
};
